export default "__VITE_ASSET__olI2_uap__"